/* eslint-disable react/no-array-index-key */
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dimmer, Loader } from 'semantic-ui-react';

import 'components/pages/RCWPage/_RCWPage.scss';

import { getMemberships } from 'actions/memberships';
import { useEffectAsync } from 'controls/hooks';

import { Image } from 'components/atoms/Image/Image';
import { Header } from 'components/atoms/Header/Header';
import { MembershipItem } from '../MembershipItem/MembershipItem';

import { MEMBERSHIP_TYPES, OFFERS_TIERS_TITLES } from '../constants';
import { PageCopy } from '../Sections/PageCopy';
import { AditionalBenefits } from '../Sections/AditionalBenefits';

export const Template = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const userInfo = useSelector((state) => state.userInfo);
  const [memberships, setMemberships] = useState({});
  const [activeCTAbtn, setActiveCTAbtn] = useState(null);
  const [trialStatus, setTrialStatus] = useState({
    freeTrial: true,
    hasActiveSubscription: false,
  });

  useEffectAsync(async () => {
    if (userInfo) {
      setLoading(true);
      const [offers, trial] = await dispatch(getMemberships());
      setMemberships(offers);
      setTrialStatus(trial);
      const activeOffer = offers[MEMBERSHIP_TYPES.monthly]?.filter(
        ({ title: { us } }) => us.includes(OFFERS_TIERS_TITLES.ultimate),
      );
      setActiveCTAbtn(activeOffer.length > 0 ? activeOffer[0] : null);
      setLoading(false);
    }
  }, [userInfo]);

  // will be pased to MembershipItem as children prop
  const pageContent = [
    { name: 'heroContent', value: <Image name='JD-800_OpenGraph.png' className='membership-item__segment--hero' />, hasCTABtn: true },
    {
      name: 'purchasePage', value: <PageCopy />, hasCTABtn: true, className: 'membership-item__copy-content',
    },
    { name: 'valueProp', value: <AditionalBenefits />, hasCTABtn: false },
    {
      name: 'video', value: <iframe height='500' src='https://www.youtube.com/embed/4K3p3pbqMB8' frameBorder='0' allowFullScreen={false} title='video' />, hasCTABtn: false, className: 'membership-item__video',
    },
  ];

  return (
    <div className='main'>
      <Image name='logo-no-bg.png' className='main__logo' />
      <Header text='Join Roland Cloud' position='center' />
      <Header text='Access the authentic JD-800 Software Synthesizer' position='center' />
      {loading ? (
        <Dimmer active>
          <Loader>Loading</Loader>
        </Dimmer>
      ) : (
        <div className='main__list'>
          {memberships && activeCTAbtn && (
            pageContent.map(({
              name, value, hasCTABtn, ...rest
            }) => (
              <MembershipItem
                key={name}
                item={activeCTAbtn}
                trialStatus={trialStatus}
                content={value}
                hasCTABtn={hasCTABtn}
                {...rest}
              />
            ))
          )}
        </div>
      )}
      <div>Free 30-day Ultimate Trial available exclusively for new users</div>
    </div>
  );
};
